<template>
  <div class="about">
    <div id="graypage">
      <div class="page_content">
        <div class="about_box machinepage_sections">
          <div class="about_text">
            <h2>
              <div>創業1998年 <span class="eigo">HISTORY</span></div>
            </h2>
            <p>
              1998年に設立した株式会社スカンジナビアは、これまで以上に質の良いサービスをお客様に提供するため、
              2013年に株式会社スカンジナビアサービスとして新たに発足いたしました。
            </p>
            <p> 株式会社スカンジナビアサービスは、脱毛・フェイシャル・痩身・育毛・リラクセーションの5つの分野でのプレミアムライフスタイル製品を取り扱う日本のイノベーター企業です。私たちは提供する製品の設計から製作・マーケティング・流通まで自社で一貫して行っております。
            </p>
            <p>       株式会社スカンジナビアサービスは美容市場で常に発展を遂げてきました。弊社の代表製品である光脱毛・光フェイシャル機器「POWERLITE<sup>®</sup>」シリーズをはじめ、育毛機器「HAIRMEDIC SYSTEM<sup>®</sup>」、痩身機器「EVOLUTION SLIM<sup>®</sup>」「SMART DREN<sup>®</sup>」、ヘッド＆ボディ機器「Dr-PRO<sup>®</sup>」などのブランド名は、日本で広く知られています。
            </p>
            <p>              北欧スカンジナビア半島を中心に欧州全体に強力なネットワークを持ち、常に時代の最先端の技術を行使し、高品質、高性能、安全性を兼ね備えた商品とサービスを提供していくことで、私たちの事業をより成長、拡大させていきます。
            </p>
          </div>
          <div class="history_img">
            <img src="/assets/img/sslogo.jpg">
          </div>
        </div>

        <div class="about_box machinepage_sections">
          <div class="motto_img">
            <img src="/assets/img/IMG_4700crop.jpg">
          </div>
          <div class="about_text">
            <h2>
              <div>モットー <span class="eigo">MOTTO</span></div>
            </h2>
            <p> 私たちは「美の発展に貢献し続ける」をモットーに、今後一層の努力を重ねてまいります。従来と変わらぬご支援を賜りますようお願い申し上げます。
            </p>
          </div>
        </div>

        <div class="about_box machinepage_sections">
          <div class="about_text">
            <h2>
              <div>私たちだからできること<span class="eigo">FACE TO FACE</span></div>
            </h2>
            <p>
              訪問デモまたは弊社にて体験をご希望の方、又は       導入をご検討中のお客様には、他社製品との違いを実感頂けたら幸いです。もちろん、費用は無料とさせて頂いてます。
            </p>
          </div>
          <div class="face2face_img">
            <img src="/assets/img/_MG_6272-450x324.jpg">
          </div>
        </div>

        <div class="about_box machinepage_sections">
          <div class="safety_img">
            <img src="/assets/img/_MG_6570-600x439.jpg">
          </div>
          <div class="about_text">
            <h2>
              <div>安心・安全<span class="eigo">SAFETY</span></div>
            </h2>
            <p> 株式会社スカンジナビアサービスの機器はすべて自社開発で、製造から組み立てまで日本国内で丁寧に行われています。高品質で安全・安心の100％国内生産のため、機器の故障は少なく、どこよりも長期間使用し続けられる耐久性の高さが特徴です。
            </p>
          </div>
        </div>

        <div class="about_box machinepage_sections">
          <div class="about_text">
            <h2>
              <div>サービス<span class="eigo">SERVICE</span></div>
            </h2>
            <p>             パーツ管理やリペアもサービスの一貫で、何年経っても部品がすぐ手に入るのも自社生産ならではのメリットです。さらに万一の故障の際は「365日24時間サービスコール受付、48時間以内対応」というメンテナンス体制で、お客様のご負担を大幅に軽減します。
            </p>
          </div>
          <div class="service_img">
            <img src="/assets/img/kaihatsu2.jpg">
          </div>
        </div>
        <shop-movie-partner></shop-movie-partner>
      </div>
      <footer2></footer2>
    </div>

  </div>
</template>

<script>

 export default {
   name: 'about',
   components: {
     'shop-movie-partner': () => import('../components/ShopMoviePartner.vue'),
     footer2: () => import('../components/Footer2.vue')
   },
 }
</script>

<style lang="scss" scoped>
 .about {
   margin-top: 50px;
 }
 @media (min-width: 601px) {
   .about {
     margin-top: 80px; /* to deal with floating menu*/
   }
 }
 .about_box{
   background-color: #fff;
   display: flex;
   // padding-bottom: 10px;
   flex-wrap: wrap;
   // img {
     //     width: 480px;
     // }
   .about_text {
     // background-color: aqua;
     padding: 20px;
     flex: 1;
     color: #777;
     font-family: sans-serif;
     font-size: 0.9em;
     padding-right: 30px;
     h2 {
       display: flex;
       // align-items: center;
       font-family: serif;
       margin-bottom: 20px;
       .vbar {
         width: 6px;
         height: 1.2em;
         background-color: #777;
         margin-right: 15px;
       }
       .eigo {
         display: inline-block;
         margin-left: 10px;
         font-size: 0.5em;
         padding: 2px 4px 0px 4px;
         border: 1px solid #999;
         position: relative;
         top: -4px;
       }
     }
   }
   .history_img {
     img { width: 450px; }
     margin: 60px 10px 0 0;
   }
   .motto_img {
     img { width: 300px; }
     margin: 0;
     padding: 10px;
   }
   .face2face_img {
     img { width: 250px; }
     margin: 0;
     padding: 10px;
   }
   .safety_img {
     img { width: 300px; }
     margin: 0;
     padding: 10px;
   }
   .service_img {
     img { width: 250px; }
     margin: 0;
     padding: 10px;
   }
 }
 @media (max-width: 600px) {
   .about_box {
     flex-direction: column;
     .history_img, .motto_img, .face2face_img, .safety_img, .service_img {
       img {
         width: 100%;
       }
     }
   }
 }
</style>
